import * as React from "react"
import { Link } from "gatsby"
import "../styles/footer.css"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info Section */}
          <div className="footer-section">
            <h3 className="footer-title">
              <img src="/icon.svg" alt="Bisma Logo" className="footer-logo-icon" />
            </h3>
            <p className="footer-description">
              Expert en isolation thermique par l'extérieur et rénovation énergétique.
            </p>
            <div className="footer-qualibat">
              <img src="/images/others/qualibat.png" alt="Qualibat Certification" />
            </div>
          </div>

          {/* Contact Info Section */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-list">
              <li className="footer-contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span className="footer-service-item">254 rue Vendôme, 69003 Lyon</span>
              </li>
              <li className="footer-contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <a href="tel:+33 9 83 51 94 98">+33 9 83 51 94 98</a>
              </li>
              <li className="footer-contact-item">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <a href="mailto:contact@bisma.fr">contact@bisma.fr</a>
              </li>
            </ul>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section">
            <h4 className="footer-heading">Liens Rapides</h4>
            <ul className="footer-list">
              <li>
                <Link to="/" className="footer-link">Accueil</Link>
              </li>
              <li>
                <Link to="/a-propos" className="footer-link">À propos</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link">Nos services</Link>
              </li>
              <li>
                <Link to="/a-propos/nos-realisations" className="footer-link">Nos réalisations</Link>
              </li>
               <li>
                 <Link to="/blog" className="footer-link">Blog</Link>
               </li>
              <li>
                <Link to="/contact" className="footer-link">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services Section */}
          <div className="footer-section">
            <h4 className="footer-heading">Nos Services</h4>
            <ul className="footer-list">
              <li className="footer-service-item">
                <Link to="/services/renovation-dampleur" className="footer-link">Rénovation d'envergure</Link>
              </li>
              <li className="footer-service-item">
                <Link to="/services/isolation-externe" className="footer-link">Isolation thermique extérieure</Link>
              </li>
              <li className="footer-service-item">
                <Link to="/services/pompe-chaleur" className="footer-link">Pompe à chaleur</Link>
              </li>
              <li className="footer-service-item">
                <Link to="/a-propos/parrainage" className="footer-link">Parrainage</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Bisma. Tous droits réservés.
          </p>
          <div className="footer-legal">
            <Link to="/mentions-legales" className="footer-legal-link">
              Mentions légales Bisma
            </Link>
            <span className="footer-separator">|</span>
            <Link to="/politique-confidentialite" className="footer-legal-link">
              Politique de confidentialité Bisma
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
